module.exports = __webpack_public_path__ + "img/wx-logo.8c496adb.png";